// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel {
  padding: 1.5rem 2rem 2.5rem;
  max-width: 1440px;
  margin: 0 auto;
}

.admin-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 2rem;
  color: #64748b;
}

.admin-loading-ring {
  width: 48px;
  height: 48px;
  border: 3px solid #e2e8f0;
  border-top-color: #3bbddb;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin-bottom: 1.25rem;
}

.admin-inline-error {
  margin: 0 0 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: rgba(255, 107, 107, 0.12);
  color: #c0392b;
}

.admin-header {
  margin-bottom: 2rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.admin-header-brand {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.admin-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #1e3a8a 0%, #3bbddb 100%);
  color: white;
  font-size: 1.4rem;
  box-shadow: 0 6px 20px rgba(30, 58, 138, 0.25);
}

.admin-header-subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.85rem;
  color: #64748b;
  font-weight: 400;
}

.admin-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  gap: 1rem;
}

.back-to-main-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 0.65rem 1.15rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 0.88rem;
}

.back-to-main-arrow {
  transition: transform 0.2s ease;
}

.back-to-main-btn:hover {
  background: white;
  border-color: #3bbddb;
  color: #1e3a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(59, 189, 219, 0.15);
}

.back-to-main-btn:hover .back-to-main-arrow {
  transform: translateX(-3px);
}

.admin-navigation {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  padding: 0.35rem;
  background: #f1f5f9;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
}

.admin-nav-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: transparent;
  border: none;
  color: #64748b;
  padding: 0.65rem 1.1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  font-weight: 600;
  font-size: 0.88rem;
}

.admin-nav-icon {
  font-size: 1rem;
  line-height: 1;
}

.admin-nav-btn:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #1e3a8a;
}

.admin-nav-btn.active {
  background: white;
  color: #1e3a8a;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.admin-content {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.admin-header h2 {
  color: #1e293b;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.admin-actions {
  display: flex;
  gap: 1rem;
}



.refresh-btn {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.refresh-btn:hover {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
  transform: translateY(-1px);
}

/* Обзор команд */
.teams-summary {
  margin-bottom: 3rem;
}

.teams-summary h3 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.teams-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  align-items: stretch;
}

.team-card {
  background: white;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: transform 0.2s, box-shadow 0.2s;
  height: fit-content;
  display: flex;
  flex-direction: column;
  min-height: 280px;
  max-width: 320px;
}

.team-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.team-card-actions {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #f1f3f4;
  margin-top: auto;
}

.detail-view-btn {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  border: none;
  padding: 0.6rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  font-size: 0.85rem;
}

.detail-view-btn:hover {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.team-card h4 {
  color: #333;
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.2;
  word-wrap: break-word;
}

.team-stats {
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f3f4;
  flex-shrink: 0;
}

.team-stats p {
  margin: 0.4rem 0;
  color: #666;
  font-size: 0.8rem;
}

.team-metrics {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  min-height: 1.8rem;
  font-size: 0.85rem;
}

.metric span:first-child {
  color: #555;
  font-size: 0.9rem;
}

.metric-value {
  font-weight: 600;
  color: #2193b0;
  font-size: 0.9rem;
}

/* Секция графиков */
.charts-section {
  margin-top: 3rem;
}

.charts-section h3 {
  color: #333;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 2rem;
}

.chart-container {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

/* Chart Container - делаем кликабельным */
.chart-container {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.chart-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.chart-container::before {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
}

.chart-container:hover::before {
  opacity: 1;
}

.chart-container::after {
  content: '🔍';
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 11;
}

.chart-container:hover::after {
  opacity: 1;
}

/* Модальное окно для графиков */
.chart-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.3s ease;
}

.chart-modal {
  background: white;
  border-radius: 16px;
  max-width: 90vw;
  max-height: 90vh;
  width: 900px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideInScale 0.3s ease;
  overflow: hidden;
}

.chart-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e0e0e0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.chart-modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.chart-modal-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.chart-modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.chart-modal-content {
  padding: 2rem;
  max-height: calc(90vh - 100px);
  overflow-y: auto;
}

/* Анимации */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInScale {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Темная тема для модального окна */
.dark-theme .chart-modal {
  background: #1a1a1a;
  color: #ffffff;
}

.dark-theme .chart-modal-header {
  background: linear-gradient(135deg, #1e3a8a 0%, #3bbedb 100%);
  border-bottom: 1px solid #333;
}

.dark-theme .chart-modal-content {
  background: #1a1a1a;
}

/* Teams Management Styles */
.teams-management {
  animation: fadeIn 0.5s ease-out;
}

.teams-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.teams-header h3 {
  color: #333;
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
}

.teams-order-hint {
  margin: 0.35rem 0 0;
  color: #64748b;
  font-size: 0.9rem;
}

.team-drag-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #dbe3ea;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  cursor: grab;
  font-size: 0.85rem;
  line-height: 1;
  padding: 0;
  flex-shrink: 0;
}

.team-drag-handle:active {
  cursor: grabbing;
}

.team-management-card.dragging {
  opacity: 0.55;
  transform: scale(0.98);
}

.team-management-card.drag-over {
  border-color: #3bbedb;
  box-shadow: 0 0 0 2px rgba(59, 190, 219, 0.25);
}

.teams-list--reordering {
  pointer-events: none;
  opacity: 0.85;
}

.dark-theme .teams-order-hint {
  color: #cbd5e0;
}

.dark-theme .team-drag-handle {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.create-team-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.create-team-btn:hover {
  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

/* Modal Styles */
.create-team-modal,
.edit-team-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-content h4 {
  color: #333;
  margin: 0 0 1.5rem 0;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: 500;
  font-size: 0.9rem;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.save-btn,
.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.save-btn {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
}

.save-btn:hover {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.cancel-btn {
  background: #6c757d;
  color: white;
}

.cancel-btn:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

/* Teams List */
.teams-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 1.5rem;
  align-items: start;
  grid-auto-rows: min-content;
}

.team-management-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: fit-content;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

.team-management-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.team-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #f1f3f4;
  gap: 1rem;
  overflow: hidden;
}

.team-header h4 {
  color: #333;
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  flex: 1 1;
  min-width: 0;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.status-badge.active {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.status-badge.inactive {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.status-badge.archived {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.3);
}

.team-info {
  flex: 1 1;
  overflow: hidden;
}

.team-info p {
  margin: 0.5rem 0;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.team-info strong {
  color: #333;
  font-weight: 600;
  display: inline-block;
  min-width: 80px;
  margin-right: 0.5rem;
}

.team-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: auto;
}

.action-btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 80px;
  white-space: nowrap;
}

.edit-btn {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
  color: white;
}

.edit-btn:hover {
  background: linear-gradient(135deg, #fd7e14 0%, #ffc107 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
}

.export-btn {
  background: linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%);
  color: white;
}

.export-btn:hover {
  background: linear-gradient(135deg, #6f42c1 0%, #17a2b8 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);
}

.delete-btn {
  background: linear-gradient(135deg, #dc3545 0%, #e83e8c 100%);
  color: white;
}

.delete-btn:hover {
  background: linear-gradient(135deg, #e83e8c 0%, #dc3545 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Состояния загрузки и ошибок */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  color: #666;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  text-align: center;
}

.retry-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 1rem;
  transition: background-color 0.2s;
}

.retry-btn:hover {
  background: #c82333;
}

/* Темная тема */
.dark-theme .admin-panel {
  background: #1a1a1a;
  color: #e2e8f0;
}

.dark-theme .admin-header h2 {
  color: #f1f5f9;
}

.dark-theme .admin-header-subtitle {
  color: #94a3b8;
}

.dark-theme .admin-header {
  border-bottom-color: #334155;
}

.dark-theme .admin-navigation {
  background: #1e293b;
  border-color: #334155;
}

.dark-theme .admin-nav-btn {
  color: #94a3b8;
}

.dark-theme .admin-nav-btn:hover {
  background: #334155;
  color: #e2e8f0;
}

.dark-theme .admin-nav-btn.active {
  background: #334155;
  color: #7dd3fc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.dark-theme .back-to-main-btn {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e0;
}

.dark-theme .back-to-main-btn:hover {
  background: #334155;
  border-color: #3bbddb;
  color: #7dd3fc;
}

.dark-theme .admin-loading-state {
  color: #94a3b8;
}

.dark-theme .admin-loading-ring {
  border-color: #334155;
  border-top-color: #3bbddb;
}

.dark-theme .team-card,
.dark-theme .chart-container {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.dark-theme .team-card h4 {
  color: #e2e8f0;
}

.dark-theme .team-stats p {
  color: #a0aec0;
}

.dark-theme .metric span:first-child {
  color: #a0aec0;
}

.dark-theme .team-stats {
  border-bottom-color: #4a5568;
}

.dark-theme .loading-state {
  color: #a0aec0;
}

.dark-theme .error-state {
  background: #2d1b1b;
  color: #f8d7da;
  border-color: #721c24;
}

/* Dark theme for Teams Management */
.dark-theme .teams-header h3 {
  color: #e2e8f0;
}

.dark-theme .teams-header {
  border-bottom-color: #4a5568;
}

.dark-theme .modal-content {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .modal-content h4 {
  color: #e2e8f0;
}

.dark-theme .form-group label {
  color: #cbd5e0;
}

.dark-theme .form-group input,
.dark-theme .form-group textarea,
.dark-theme .form-group select {
  background: #4a5568;
  border-color: #718096;
  color: #e2e8f0;
}

.dark-theme .form-group input:focus,
.dark-theme .form-group textarea:focus,
.dark-theme .form-group select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.dark-theme .team-management-card {
  background: #2d3748;
  border-color: #4a5568;
}

.dark-theme .team-header {
  border-bottom-color: #4a5568;
}

.dark-theme .team-header h4 {
  color: #e2e8f0;
}

.dark-theme .team-info p {
  color: #cbd5e0;
}

.dark-theme .team-info strong {
  color: #e2e8f0;
}

/* Dark theme for Teams Management */
.dark-theme .teams-header h3 {
  color: #e2e8f0;
}

.dark-theme .teams-header {
  border-bottom-color: #4a5568;
}

.dark-theme .modal-content {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .modal-content h4 {
  color: #e2e8f0;
}

.dark-theme .form-group label {
  color: #cbd5e0;
}

.dark-theme .form-group input,
.dark-theme .form-group textarea,
.dark-theme .form-group select {
  background: #4a5568;
  border-color: #718096;
  color: #e2e8f0;
}

.dark-theme .form-group input:focus,
.dark-theme .form-group textarea:focus,
.dark-theme .form-group select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.dark-theme .team-management-card {
  background: #2d3748;
  border-color: #4a5568;
}

.dark-theme .team-header {
  border-bottom-color: #4a5568;
}

.dark-theme .team-header h4 {
  color: #e2e8f0;
}

.dark-theme .team-info p {
  color: #cbd5e0;
}

.dark-theme .team-info strong {
  color: #e2e8f0;
}

/* Адаптивность */
@media (max-width: 768px) {
  .admin-panel {
    padding: 1rem;
  }
  
  .admin-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .admin-header-top {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .back-to-main-btn {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }
  
  .teams-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
  }
  
  .team-card {
    min-height: auto;
    max-width: none;
  }
  
  .charts-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-container {
    padding: 1rem;
  }

  /* Teams Management Responsive */
  .teams-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .teams-list {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .team-info p {
    -webkit-line-clamp: 2;
  }
  
  .team-header h4 {
    font-size: 1.1rem;
  }

  .team-actions {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .action-btn {
    min-width: auto;
    flex: 1 1;
    min-width: 120px;
  }

  .modal-content {
    width: 95%;
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .admin-header h2 {
    font-size: 1.5rem;
  }
  
  .team-card {
    padding: 1rem;
  }
  
  .team-management-card {
    padding: 1rem;
  }
  
  .metric {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
  
  .team-actions {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .action-btn {
    min-width: 100%;
    flex: none;
  }
  
  .teams-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .team-card {
    min-height: auto;
    padding: 1rem;
    max-width: none;
  }
  
  .teams-list {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .team-info p {
    -webkit-line-clamp: 1;
    font-size: 0.8rem;
  }
  
  .team-header h4 {
    font-size: 1rem;
  }
  
  .team-info strong {
    min-width: 60px;
    font-size: 0.8rem;
  }
}

/* Стили для детального просмотра */
.detail-view-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.detail-view-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease-out;
}

.detail-view-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 2px solid #e9ecef;
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
}

.detail-view-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.detail-view-navigation {
  display: flex;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.detail-nav-btn {
  background: white;
  border: 1px solid #dee2e6;
  color: #6c757d;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.detail-nav-btn:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.detail-nav-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  border-color: #667eea;
}

.detail-view-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
}

/* Стили для вкладки метрик */
.metrics-detail-view {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.team-detail-info h4,
.metrics-detail-charts h4 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  padding: 1.5rem;
  border-radius: 8px;
  background: white;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.info-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #e9ecef;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item strong {
  color: #495057;
  margin-right: 0.5rem;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.metric-detail-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.metric-detail-card h5 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
}

.metric-progress {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.metric-progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.metric-value {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2193b0;
  text-align: center;
}

/* Стили для вкладки шагов */
.steps-detail-view h4 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.step-item {
  display: flex;
  align-items: flex-start;
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.step-number {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-right: 1rem;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-category {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
}

.step-product {
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.step-action {
  color: #495057;
  margin-bottom: 0.25rem;
}

.step-code {
  font-size: 0.9rem;
  color: #2193b0;
  font-weight: 500;
}

.no-steps {
  text-align: center;
  padding: 3rem;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 8px;
}

/* Стили для вкладки графиков */
.charts-detail-view h4 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.detail-charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 2rem;
}

.detail-chart-container {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.detail-chart-container h5 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
}

/* Темная тема для детального просмотра */
.dark-theme .detail-view-content {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .detail-view-header {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
}

.dark-theme .detail-view-navigation {
  background: #4a5568;
}

.dark-theme .detail-nav-btn {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.dark-theme .detail-nav-btn:hover {
  background: #4a5568;
}

.dark-theme .detail-nav-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
}

.dark-theme .info-grid {
  background: #2d3748;
  border-color: #4a5568;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-theme .team-detail-info h4,
.dark-theme .metrics-detail-charts h4 {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-theme .info-item strong {
  color: #e2e8f0;
}

.dark-theme .metric-detail-card,
.dark-theme .step-item,
.dark-theme .detail-chart-container {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.dark-theme .step-category {
  color: #e2e8f0;
}

.dark-theme .step-product {
  color: #a0aec0;
}

.dark-theme .step-action {
  color: #e2e8f0;
}

.dark-theme .no-steps {
  background: #4a5568;
  color: #a0aec0;
}

/* Адаптивность для детального просмотра */
@media (max-width: 768px) {
  .detail-view-content {
    width: 95%;
    max-height: 95vh;
  }

  .detail-view-navigation {
    flex-direction: column;
  }

  .detail-nav-btn {
    text-align: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .detail-charts-grid {
    grid-template-columns: 1fr;
  }

  .step-item {
    flex-direction: column;
  }

  .step-number {
    margin-bottom: 0.5rem;
    margin-right: 0;
  }
  
  .chart-modal {
    width: 95vw;
    max-height: 95vh;
    margin: 1rem;
  }
  
  .chart-modal-header {
    padding: 1rem 1.5rem;
  }
  
  .chart-modal-header h3 {
    font-size: 1.2rem;
  }
  
  .chart-modal-content {
    padding: 1.5rem;
  }
  
  .chart-container::before,
  .chart-container::after {
    display: none;
  }
} 

/* Стили для выбора цвета */
.color-picker-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.color-picker {
  width: 60px;
  height: 50px;
  border: 2px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  background: none;
  padding: 0;
}

.color-picker:hover {
  border-color: #3bbddb;
}

.color-preview {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 2px solid #ddd;
  display: inline-block;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.color-preview:hover {
  border-color: #3bbddb;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.3);
}

.color-preview:focus {
  outline: 2px solid #3bbddb;
  outline-offset: 2px;
  border-color: #3bbddb;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.3);
}

.color-preview::after {
  content: '🎨';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.color-preview:hover::after {
  opacity: 1;
}

/* Индикатор цвета команды */
.team-title-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.team-color-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

/* Темная тема для выбора цвета */
.admin-panel.dark-theme .color-picker {
  border-color: #555;
  background: #333;
}

.admin-panel.dark-theme .color-picker:hover {
  border-color: #3bbddb;
}

.admin-panel.dark-theme .color-preview {
  border-color: #555;
}

.admin-panel.dark-theme .color-preview:hover {
  border-color: #3bbddb;
  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.4);
}

.admin-panel.dark-theme .team-color-indicator {
  border-color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
} 

/* Заголовок карточки команды */
.team-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.team-card-header h4 {
  margin: 0;
  color: #333;
}

.admin-panel.dark-theme .team-card-header h4 {
  color: #fff;
} 

/* Действия в заголовке команд */
.teams-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.order-constructor-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.order-constructor-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.order-constructor-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.order-constructor-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  padding: 1rem;
}

.order-constructor-modal {
  width: min(560px, 100%);
  max-height: 85vh;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-constructor-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 1px solid #e9ecef;
}

.order-constructor-header h4 {
  margin: 0 0 0.35rem;
  color: #1e3a8a;
  font-size: 1.2rem;
}

.order-constructor-header p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
}

.order-constructor-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #64748b;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
}

.order-constructor-close:hover:not(:disabled) {
  background: #f1f5f9;
  color: #1e3a8a;
}

.team-mini-list {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 1rem 1.5rem;
  overflow-y: auto;
}

.team-mini-list--saving {
  pointer-events: none;
  opacity: 0.75;
}

.team-mini-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.team-mini-card.dragging {
  opacity: 0.55;
}

.team-mini-card.drag-over {
  border-color: #3bbedb;
  box-shadow: 0 0 0 2px rgba(59, 190, 219, 0.2);
  background: #eef9fc;
}

.team-mini-position {
  width: 1.5rem;
  text-align: center;
  font-weight: 700;
  color: #64748b;
  flex-shrink: 0;
}

.team-mini-drag-handle {
  width: 24px;
  height: 24px;
  font-size: 0.75rem;
}

.team-mini-color {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.team-mini-name {
  flex: 1 1;
  min-width: 0;
  font-weight: 600;
  color: #1e3a8a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-mini-actions {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

.team-mini-move-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #dbe3ea;
  border-radius: 6px;
  background: white;
  color: #475569;
  cursor: pointer;
  font-size: 0.85rem;
  line-height: 1;
  padding: 0;
}

.team-mini-move-btn:hover:not(:disabled) {
  background: #e6f4fa;
  border-color: #3bbedb;
  color: #1e3a8a;
}

.team-mini-move-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.order-constructor-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid #e9ecef;
}

.dark-theme .order-constructor-modal {
  background: #2d3748;
}

.dark-theme .order-constructor-header {
  border-bottom-color: #4a5568;
}

.dark-theme .order-constructor-header h4,
.dark-theme .team-mini-name {
  color: #e2e8f0;
}

.dark-theme .order-constructor-header p {
  color: #cbd5e0;
}

.dark-theme .team-mini-card {
  background: #1a202c;
  border-color: #4a5568;
}

.dark-theme .team-mini-card.drag-over {
  background: #234e52;
  border-color: #3bbedb;
}

.dark-theme .team-mini-move-btn {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.dark-theme .order-constructor-footer {
  border-top-color: #4a5568;
}

.refresh-teams-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.refresh-teams-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.admin-panel.dark-theme .refresh-teams-btn {
  background: #495057;
  border-color: #6c757d;
  color: #f8f9fa;
}

.admin-panel.dark-theme .refresh-teams-btn:hover {
  background: #6c757d;
  border-color: #adb5bd;
} 

/* Подсказка для color-preview */
.color-preview-hint {
  font-size: 11px;
  color: #666;
  text-align: center;
  margin: 0;
  opacity: 0.8;
}

.admin-panel.dark-theme .color-preview-hint {
  color: #aaa;
} 

/* Кнопка быстрого выбора цвета */
.quick-color-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  margin-top: 8px;
}

.quick-color-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.quick-color-btn:active {
  transform: translateY(0);
}

/* Модальное окно палитры цветов */
.color-palette-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.color-palette-modal {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.color-palette-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.color-palette-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.color-palette-close {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.color-palette-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

.color-palette-content {
  padding: 24px;
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.color-option {
  aspect-ratio: 1;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.color-option:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.color-option:active {
  transform: scale(1.05);
}

.color-name {
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  text-align: center;
  line-height: 1.2;
}

.color-option:hover .color-name {
  opacity: 1;
}

/* Темная тема для палитры цветов */
.admin-panel.dark-theme .color-palette-modal {
  background: #2d3748;
  color: white;
}

.admin-panel.dark-theme .color-palette-content {
  background: #2d3748;
}

.admin-panel.dark-theme .quick-color-btn {
  background: linear-gradient(135deg, #4c51bf 0%, #553c9a 100%);
  box-shadow: 0 2px 8px rgba(76, 81, 191, 0.4);
}

.admin-panel.dark-theme .quick-color-btn:hover {
  box-shadow: 0 4px 12px rgba(76, 81, 191, 0.5);
} `, "",{"version":3,"sources":["webpack://./src/components/admin/AdminPanel.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;;;AAIA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".admin-panel {\r\n  padding: 1.5rem 2rem 2.5rem;\r\n  max-width: 1440px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.admin-loading-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 5rem 2rem;\r\n  color: #64748b;\r\n}\r\n\r\n.admin-loading-ring {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 3px solid #e2e8f0;\r\n  border-top-color: #3bbddb;\r\n  border-radius: 50%;\r\n  animation: spin 0.9s linear infinite;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.admin-inline-error {\r\n  margin: 0 0 16px;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  background: rgba(255, 107, 107, 0.12);\r\n  color: #c0392b;\r\n}\r\n\r\n.admin-header {\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1.25rem;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n\r\n.admin-header-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.admin-header-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 14px;\r\n  background: linear-gradient(135deg, #1e3a8a 0%, #3bbddb 100%);\r\n  color: white;\r\n  font-size: 1.4rem;\r\n  box-shadow: 0 6px 20px rgba(30, 58, 138, 0.25);\r\n}\r\n\r\n.admin-header-subtitle {\r\n  margin: 0.2rem 0 0;\r\n  font-size: 0.85rem;\r\n  color: #64748b;\r\n  font-weight: 400;\r\n}\r\n\r\n.admin-header-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1.25rem;\r\n  gap: 1rem;\r\n}\r\n\r\n.back-to-main-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: #f8fafc;\r\n  color: #475569;\r\n  border: 1px solid #e2e8f0;\r\n  padding: 0.65rem 1.15rem;\r\n  border-radius: 10px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.back-to-main-arrow {\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.back-to-main-btn:hover {\r\n  background: white;\r\n  border-color: #3bbddb;\r\n  color: #1e3a8a;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 16px rgba(59, 189, 219, 0.15);\r\n}\r\n\r\n.back-to-main-btn:hover .back-to-main-arrow {\r\n  transform: translateX(-3px);\r\n}\r\n\r\n.admin-navigation {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  flex-wrap: wrap;\r\n  padding: 0.35rem;\r\n  background: #f1f5f9;\r\n  border-radius: 14px;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.admin-nav-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  background: transparent;\r\n  border: none;\r\n  color: #64748b;\r\n  padding: 0.65rem 1.1rem;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n  font-weight: 600;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.admin-nav-icon {\r\n  font-size: 1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.admin-nav-btn:hover {\r\n  background: rgba(255, 255, 255, 0.8);\r\n  color: #1e3a8a;\r\n}\r\n\r\n.admin-nav-btn.active {\r\n  background: white;\r\n  color: #1e3a8a;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.admin-content {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.admin-header h2 {\r\n  color: #1e293b;\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.admin-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n\r\n\r\n.refresh-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.refresh-btn:hover {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Обзор команд */\r\n.teams-summary {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.teams-summary h3 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.teams-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 1.5rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.team-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.25rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  height: fit-content;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 280px;\r\n  max-width: 320px;\r\n}\r\n\r\n.team-card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.team-card-actions {\r\n  margin-top: 1rem;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid #f1f3f4;\r\n  margin-top: auto;\r\n}\r\n\r\n.detail-view-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.6rem 1rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  width: 100%;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.detail-view-btn:hover {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.team-card h4 {\r\n  color: #333;\r\n  margin: 0 0 1rem 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.team-stats {\r\n  margin-bottom: 1rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #f1f3f4;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-stats p {\r\n  margin: 0.4rem 0;\r\n  color: #666;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.team-metrics {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  flex: 1;\r\n}\r\n\r\n.metric {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.4rem 0;\r\n  min-height: 1.8rem;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.metric span:first-child {\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.metric-value {\r\n  font-weight: 600;\r\n  color: #2193b0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Секция графиков */\r\n.charts-section {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.charts-section h3 {\r\n  color: #333;\r\n  margin-bottom: 2rem;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.charts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.chart-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n/* Chart Container - делаем кликабельным */\r\n.chart-container {\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.chart-container:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.chart-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: rgba(102, 126, 234, 0.1);\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n  z-index: 10;\r\n}\r\n\r\n.chart-container:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.chart-container::after {\r\n  content: '🔍';\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  font-size: 14px;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n  z-index: 11;\r\n}\r\n\r\n.chart-container:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Модальное окно для графиков */\r\n.chart-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(5px);\r\n  animation: fadeIn 0.3s ease;\r\n}\r\n\r\n.chart-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  width: 900px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  animation: slideInScale 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.chart-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem 2rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.chart-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.chart-modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.chart-modal-close:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.chart-modal-content {\r\n  padding: 2rem;\r\n  max-height: calc(90vh - 100px);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Анимации */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideInScale {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.8) translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n/* Темная тема для модального окна */\r\n.dark-theme .chart-modal {\r\n  background: #1a1a1a;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .chart-modal-header {\r\n  background: linear-gradient(135deg, #1e3a8a 0%, #3bbedb 100%);\r\n  border-bottom: 1px solid #333;\r\n}\r\n\r\n.dark-theme .chart-modal-content {\r\n  background: #1a1a1a;\r\n}\r\n\r\n/* Teams Management Styles */\r\n.teams-management {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n.teams-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.teams-header h3 {\r\n  color: #333;\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.teams-order-hint {\r\n  margin: 0.35rem 0 0;\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.team-drag-handle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 1px solid #dbe3ea;\r\n  border-radius: 6px;\r\n  background: #f8fafc;\r\n  color: #64748b;\r\n  cursor: grab;\r\n  font-size: 0.85rem;\r\n  line-height: 1;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-drag-handle:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.team-management-card.dragging {\r\n  opacity: 0.55;\r\n  transform: scale(0.98);\r\n}\r\n\r\n.team-management-card.drag-over {\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 2px rgba(59, 190, 219, 0.25);\r\n}\r\n\r\n.teams-list--reordering {\r\n  pointer-events: none;\r\n  opacity: 0.85;\r\n}\r\n\r\n.dark-theme .teams-order-hint {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .team-drag-handle {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.create-team-btn {\r\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.create-team-btn:hover {\r\n  background: linear-gradient(135deg, #20c997 0%, #28a745 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n/* Modal Styles */\r\n.create-team-modal,\r\n.edit-team-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px) scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.modal-content h4 {\r\n  color: #333;\r\n  margin: 0 0 1.5rem 0;\r\n  font-size: 1.4rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  color: #555;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.form-group input,\r\n.form-group textarea,\r\n.form-group select {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: 2px solid #e9ecef;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  transition: border-color 0.3s ease;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group textarea:focus,\r\n.form-group select:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.form-group textarea {\r\n  min-height: 80px;\r\n  resize: vertical;\r\n}\r\n\r\n.modal-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.save-btn,\r\n.cancel-btn {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.save-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n}\r\n\r\n.save-btn:hover {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.cancel-btn {\r\n  background: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.cancel-btn:hover {\r\n  background: #5a6268;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\r\n}\r\n\r\n/* Teams List */\r\n.teams-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));\r\n  gap: 1.5rem;\r\n  align-items: start;\r\n  grid-auto-rows: min-content;\r\n}\r\n\r\n.team-management-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  height: fit-content;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  min-width: 0;\r\n}\r\n\r\n.team-management-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.team-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 1rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid #f1f3f4;\r\n  gap: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.team-header h4 {\r\n  color: #333;\r\n  margin: 0;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.status-badge {\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.status-badge.active {\r\n  background: rgba(40, 167, 69, 0.1);\r\n  color: #28a745;\r\n  border: 1px solid rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.status-badge.inactive {\r\n  background: rgba(255, 193, 7, 0.1);\r\n  color: #ffc107;\r\n  border: 1px solid rgba(255, 193, 7, 0.3);\r\n}\r\n\r\n.status-badge.archived {\r\n  background: rgba(220, 53, 69, 0.1);\r\n  color: #dc3545;\r\n  border: 1px solid rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.team-info {\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.team-info p {\r\n  margin: 0.5rem 0;\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  hyphens: auto;\r\n  max-width: 100%;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.team-info strong {\r\n  color: #333;\r\n  font-weight: 600;\r\n  display: inline-block;\r\n  min-width: 80px;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.team-actions {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n  flex-wrap: wrap;\r\n  margin-top: auto;\r\n}\r\n\r\n.action-btn {\r\n  padding: 0.5rem 1rem;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 0.8rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  flex: 1;\r\n  min-width: 80px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.edit-btn {\r\n  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);\r\n  color: white;\r\n}\r\n\r\n.edit-btn:hover {\r\n  background: linear-gradient(135deg, #fd7e14 0%, #ffc107 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);\r\n}\r\n\r\n.export-btn {\r\n  background: linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%);\r\n  color: white;\r\n}\r\n\r\n.export-btn:hover {\r\n  background: linear-gradient(135deg, #6f42c1 0%, #17a2b8 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(23, 162, 184, 0.3);\r\n}\r\n\r\n.delete-btn {\r\n  background: linear-gradient(135deg, #dc3545 0%, #e83e8c 100%);\r\n  color: white;\r\n}\r\n\r\n.delete-btn:hover {\r\n  background: linear-gradient(135deg, #e83e8c 0%, #dc3545 100%);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n/* Состояния загрузки и ошибок */\r\n.loading-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4rem;\r\n  color: #666;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #667eea;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.error-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n  border: 1px solid #f5c6cb;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.retry-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin-top: 1rem;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: #c82333;\r\n}\r\n\r\n/* Темная тема */\r\n.dark-theme .admin-panel {\r\n  background: #1a1a1a;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .admin-header h2 {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.dark-theme .admin-header-subtitle {\r\n  color: #94a3b8;\r\n}\r\n\r\n.dark-theme .admin-header {\r\n  border-bottom-color: #334155;\r\n}\r\n\r\n.dark-theme .admin-navigation {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n}\r\n\r\n.dark-theme .admin-nav-btn {\r\n  color: #94a3b8;\r\n}\r\n\r\n.dark-theme .admin-nav-btn:hover {\r\n  background: #334155;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .admin-nav-btn.active {\r\n  background: #334155;\r\n  color: #7dd3fc;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.dark-theme .back-to-main-btn {\r\n  background: #1e293b;\r\n  border-color: #334155;\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .back-to-main-btn:hover {\r\n  background: #334155;\r\n  border-color: #3bbddb;\r\n  color: #7dd3fc;\r\n}\r\n\r\n.dark-theme .admin-loading-state {\r\n  color: #94a3b8;\r\n}\r\n\r\n.dark-theme .admin-loading-ring {\r\n  border-color: #334155;\r\n  border-top-color: #3bbddb;\r\n}\r\n\r\n.dark-theme .team-card,\r\n.dark-theme .chart-container {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-card h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-stats p {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .metric span:first-child {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .team-stats {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .loading-state {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .error-state {\r\n  background: #2d1b1b;\r\n  color: #f8d7da;\r\n  border-color: #721c24;\r\n}\r\n\r\n/* Dark theme for Teams Management */\r\n.dark-theme .teams-header h3 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .teams-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .modal-content {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .modal-content h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .form-group label {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .form-group input,\r\n.dark-theme .form-group textarea,\r\n.dark-theme .form-group select {\r\n  background: #4a5568;\r\n  border-color: #718096;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .form-group input:focus,\r\n.dark-theme .form-group textarea:focus,\r\n.dark-theme .form-group select:focus {\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.dark-theme .team-management-card {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.dark-theme .team-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .team-header h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-info p {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .team-info strong {\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* Dark theme for Teams Management */\r\n.dark-theme .teams-header h3 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .teams-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .modal-content {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .modal-content h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .form-group label {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .form-group input,\r\n.dark-theme .form-group textarea,\r\n.dark-theme .form-group select {\r\n  background: #4a5568;\r\n  border-color: #718096;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .form-group input:focus,\r\n.dark-theme .form-group textarea:focus,\r\n.dark-theme .form-group select:focus {\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.dark-theme .team-management-card {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.dark-theme .team-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .team-header h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .team-info p {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .team-info strong {\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .admin-panel {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .admin-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .admin-header-top {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .back-to-main-btn {\r\n    padding: 0.6rem 1rem;\r\n    font-size: 0.85rem;\r\n  }\r\n  \r\n  .teams-grid {\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .team-card {\r\n    min-height: auto;\r\n    max-width: none;\r\n  }\r\n  \r\n  .charts-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .chart-container {\r\n    padding: 1rem;\r\n  }\r\n\r\n  /* Teams Management Responsive */\r\n  .teams-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .teams-list {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .team-info p {\r\n    -webkit-line-clamp: 2;\r\n  }\r\n  \r\n  .team-header h4 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .team-actions {\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .action-btn {\r\n    min-width: auto;\r\n    flex: 1;\r\n    min-width: 120px;\r\n  }\r\n\r\n  .modal-content {\r\n    width: 95%;\r\n    padding: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .admin-header h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .team-card {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .team-management-card {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .metric {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.25rem;\r\n  }\r\n  \r\n  .team-actions {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .action-btn {\r\n    min-width: 100%;\r\n    flex: none;\r\n  }\r\n  \r\n  .teams-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .team-card {\r\n    min-height: auto;\r\n    padding: 1rem;\r\n    max-width: none;\r\n  }\r\n  \r\n  .teams-list {\r\n    grid-template-columns: 1fr;\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .team-info p {\r\n    -webkit-line-clamp: 1;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .team-header h4 {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .team-info strong {\r\n    min-width: 60px;\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n/* Стили для детального просмотра */\r\n.detail-view-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.detail-view-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 1200px;\r\n  max-height: 90vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n.detail-view-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem;\r\n  border-bottom: 2px solid #e9ecef;\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n}\r\n\r\n.detail-view-header h3 {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.detail-view-navigation {\r\n  display: flex;\r\n  gap: 1rem;\r\n  padding: 1rem 1.5rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.detail-nav-btn {\r\n  background: white;\r\n  border: 1px solid #dee2e6;\r\n  color: #6c757d;\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-weight: 500;\r\n}\r\n\r\n.detail-nav-btn:hover {\r\n  background: #e9ecef;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.detail-nav-btn.active {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  border-color: #667eea;\r\n}\r\n\r\n.detail-view-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 1.5rem;\r\n}\r\n\r\n/* Стили для вкладки метрик */\r\n.metrics-detail-view {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.team-detail-info h4,\r\n.metrics-detail-charts h4 {\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  background: white;\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 8px;\r\n  border: 1px solid #e9ecef;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 1rem;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  background: white;\r\n  border: 1px solid #e9ecef;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.info-item {\r\n  padding: 0.5rem 0;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.info-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-item strong {\r\n  color: #495057;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.metrics-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.metric-detail-card {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.metric-detail-card h5 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.metric-progress {\r\n  width: 100%;\r\n  height: 8px;\r\n  background: #e9ecef;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.metric-progress-bar {\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.metric-value {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: #2193b0;\r\n  text-align: center;\r\n}\r\n\r\n/* Стили для вкладки шагов */\r\n.steps-detail-view h4 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.steps-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.step-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.step-number {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 600;\r\n  margin-right: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.step-content {\r\n  flex: 1;\r\n}\r\n\r\n.step-category {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.step-product {\r\n  color: #6c757d;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.step-action {\r\n  color: #495057;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.step-code {\r\n  font-size: 0.9rem;\r\n  color: #2193b0;\r\n  font-weight: 500;\r\n}\r\n\r\n.no-steps {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  color: #6c757d;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Стили для вкладки графиков */\r\n.charts-detail-view h4 {\r\n  color: #333;\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.detail-charts-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\r\n  gap: 2rem;\r\n}\r\n\r\n.detail-chart-container {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.detail-chart-container h5 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n\r\n/* Темная тема для детального просмотра */\r\n.dark-theme .detail-view-content {\r\n  background: #2d3748;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .detail-view-header {\r\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\r\n}\r\n\r\n.dark-theme .detail-view-navigation {\r\n  background: #4a5568;\r\n}\r\n\r\n.dark-theme .detail-nav-btn {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .detail-nav-btn:hover {\r\n  background: #4a5568;\r\n}\r\n\r\n.dark-theme .detail-nav-btn.active {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n}\r\n\r\n.dark-theme .info-grid {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .team-detail-info h4,\r\n.dark-theme .metrics-detail-charts h4 {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .info-item strong {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .metric-detail-card,\r\n.dark-theme .step-item,\r\n.dark-theme .detail-chart-container {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .step-category {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .step-product {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .step-action {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .no-steps {\r\n  background: #4a5568;\r\n  color: #a0aec0;\r\n}\r\n\r\n/* Адаптивность для детального просмотра */\r\n@media (max-width: 768px) {\r\n  .detail-view-content {\r\n    width: 95%;\r\n    max-height: 95vh;\r\n  }\r\n\r\n  .detail-view-navigation {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .detail-nav-btn {\r\n    text-align: center;\r\n  }\r\n\r\n  .info-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .metrics-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .detail-charts-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .step-item {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .step-number {\r\n    margin-bottom: 0.5rem;\r\n    margin-right: 0;\r\n  }\r\n  \r\n  .chart-modal {\r\n    width: 95vw;\r\n    max-height: 95vh;\r\n    margin: 1rem;\r\n  }\r\n  \r\n  .chart-modal-header {\r\n    padding: 1rem 1.5rem;\r\n  }\r\n  \r\n  .chart-modal-header h3 {\r\n    font-size: 1.2rem;\r\n  }\r\n  \r\n  .chart-modal-content {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .chart-container::before,\r\n  .chart-container::after {\r\n    display: none;\r\n  }\r\n} \r\n\r\n/* Стили для выбора цвета */\r\n.color-picker-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.color-picker {\r\n  width: 60px;\r\n  height: 50px;\r\n  border: 2px solid #ddd;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  background: none;\r\n  padding: 0;\r\n}\r\n\r\n.color-picker:hover {\r\n  border-color: #3bbddb;\r\n}\r\n\r\n.color-preview {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 6px;\r\n  border: 2px solid #ddd;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  position: relative;\r\n}\r\n\r\n.color-preview:hover {\r\n  border-color: #3bbddb;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.3);\r\n}\r\n\r\n.color-preview:focus {\r\n  outline: 2px solid #3bbddb;\r\n  outline-offset: 2px;\r\n  border-color: #3bbddb;\r\n  transform: scale(1.05);\r\n  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.3);\r\n}\r\n\r\n.color-preview::after {\r\n  content: '🎨';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  font-size: 14px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.color-preview:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Индикатор цвета команды */\r\n.team-title-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.team-color-indicator {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Темная тема для выбора цвета */\r\n.admin-panel.dark-theme .color-picker {\r\n  border-color: #555;\r\n  background: #333;\r\n}\r\n\r\n.admin-panel.dark-theme .color-picker:hover {\r\n  border-color: #3bbddb;\r\n}\r\n\r\n.admin-panel.dark-theme .color-preview {\r\n  border-color: #555;\r\n}\r\n\r\n.admin-panel.dark-theme .color-preview:hover {\r\n  border-color: #3bbddb;\r\n  box-shadow: 0 2px 8px rgba(59, 189, 219, 0.4);\r\n}\r\n\r\n.admin-panel.dark-theme .team-color-indicator {\r\n  border-color: #333;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\r\n} \r\n\r\n/* Заголовок карточки команды */\r\n.team-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.team-card-header h4 {\r\n  margin: 0;\r\n  color: #333;\r\n}\r\n\r\n.admin-panel.dark-theme .team-card-header h4 {\r\n  color: #fff;\r\n} \r\n\r\n/* Действия в заголовке команд */\r\n.teams-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.order-constructor-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 0.75rem 1.25rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.order-constructor-btn:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.order-constructor-btn:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.order-constructor-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n  padding: 1rem;\r\n}\r\n\r\n.order-constructor-modal {\r\n  width: min(560px, 100%);\r\n  max-height: 85vh;\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.order-constructor-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 1rem;\r\n  padding: 1.25rem 1.5rem 1rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.order-constructor-header h4 {\r\n  margin: 0 0 0.35rem;\r\n  color: #1e3a8a;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.order-constructor-header p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.order-constructor-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n.order-constructor-close:hover:not(:disabled) {\r\n  background: #f1f5f9;\r\n  color: #1e3a8a;\r\n}\r\n\r\n.team-mini-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.65rem;\r\n  padding: 1rem 1.5rem;\r\n  overflow-y: auto;\r\n}\r\n\r\n.team-mini-list--saving {\r\n  pointer-events: none;\r\n  opacity: 0.75;\r\n}\r\n\r\n.team-mini-card {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.team-mini-card.dragging {\r\n  opacity: 0.55;\r\n}\r\n\r\n.team-mini-card.drag-over {\r\n  border-color: #3bbedb;\r\n  box-shadow: 0 0 0 2px rgba(59, 190, 219, 0.2);\r\n  background: #eef9fc;\r\n}\r\n\r\n.team-mini-position {\r\n  width: 1.5rem;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  color: #64748b;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-mini-drag-handle {\r\n  width: 24px;\r\n  height: 24px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.team-mini-color {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-mini-name {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-weight: 600;\r\n  color: #1e3a8a;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.team-mini-actions {\r\n  display: flex;\r\n  gap: 0.35rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.team-mini-move-btn {\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 1px solid #dbe3ea;\r\n  border-radius: 6px;\r\n  background: white;\r\n  color: #475569;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  line-height: 1;\r\n  padding: 0;\r\n}\r\n\r\n.team-mini-move-btn:hover:not(:disabled) {\r\n  background: #e6f4fa;\r\n  border-color: #3bbedb;\r\n  color: #1e3a8a;\r\n}\r\n\r\n.team-mini-move-btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.order-constructor-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.75rem;\r\n  padding: 1rem 1.5rem 1.25rem;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.dark-theme .order-constructor-modal {\r\n  background: #2d3748;\r\n}\r\n\r\n.dark-theme .order-constructor-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.dark-theme .order-constructor-header h4,\r\n.dark-theme .team-mini-name {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .order-constructor-header p {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.dark-theme .team-mini-card {\r\n  background: #1a202c;\r\n  border-color: #4a5568;\r\n}\r\n\r\n.dark-theme .team-mini-card.drag-over {\r\n  background: #234e52;\r\n  border-color: #3bbedb;\r\n}\r\n\r\n.dark-theme .team-mini-move-btn {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .order-constructor-footer {\r\n  border-top-color: #4a5568;\r\n}\r\n\r\n.refresh-teams-btn {\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  color: #495057;\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.refresh-teams-btn:hover {\r\n  background: #e9ecef;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.admin-panel.dark-theme .refresh-teams-btn {\r\n  background: #495057;\r\n  border-color: #6c757d;\r\n  color: #f8f9fa;\r\n}\r\n\r\n.admin-panel.dark-theme .refresh-teams-btn:hover {\r\n  background: #6c757d;\r\n  border-color: #adb5bd;\r\n} \r\n\r\n/* Подсказка для color-preview */\r\n.color-preview-hint {\r\n  font-size: 11px;\r\n  color: #666;\r\n  text-align: center;\r\n  margin: 0;\r\n  opacity: 0.8;\r\n}\r\n\r\n.admin-panel.dark-theme .color-preview-hint {\r\n  color: #aaa;\r\n} \r\n\r\n/* Кнопка быстрого выбора цвета */\r\n.quick-color-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\r\n  margin-top: 8px;\r\n}\r\n\r\n.quick-color-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n.quick-color-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* Модальное окно палитры цветов */\r\n.color-palette-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.color-palette-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  animation: slideIn 0.3s ease;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.9) translateY(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: scale(1) translateY(0);\r\n  }\r\n}\r\n\r\n.color-palette-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.color-palette-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.color-palette-close {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.color-palette-close:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.color-palette-content {\r\n  padding: 24px;\r\n}\r\n\r\n.color-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 12px;\r\n}\r\n\r\n.color-option {\r\n  aspect-ratio: 1;\r\n  border: none;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n}\r\n\r\n.color-option:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.color-option:active {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.color-name {\r\n  color: white;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n  text-align: center;\r\n  line-height: 1.2;\r\n}\r\n\r\n.color-option:hover .color-name {\r\n  opacity: 1;\r\n}\r\n\r\n/* Темная тема для палитры цветов */\r\n.admin-panel.dark-theme .color-palette-modal {\r\n  background: #2d3748;\r\n  color: white;\r\n}\r\n\r\n.admin-panel.dark-theme .color-palette-content {\r\n  background: #2d3748;\r\n}\r\n\r\n.admin-panel.dark-theme .quick-color-btn {\r\n  background: linear-gradient(135deg, #4c51bf 0%, #553c9a 100%);\r\n  box-shadow: 0 2px 8px rgba(76, 81, 191, 0.4);\r\n}\r\n\r\n.admin-panel.dark-theme .quick-color-btn:hover {\r\n  box-shadow: 0 4px 12px rgba(76, 81, 191, 0.5);\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
